import {
  ProductAnalyticsInputSchema,
  ProductAnalyticsOutputSchema,
} from "@redotech/redo-analytics-common/returns-claims/product-analytics";
import * as z from "zod";

export const getReturnAnalyticsByProduct = {
  name: "getReturnAnalyticsByProduct" as const,
  input: ProductAnalyticsInputSchema,
  output: ProductAnalyticsOutputSchema,
};

export type ReturnAnalyticsByProduct = z.infer<
  typeof getReturnAnalyticsByProduct.output
>;
